// extracted by mini-css-extract-plugin
export default {"gaugeWrapper":"Gauge_gaugeWrapper__Vqkth"};